import useOrgsOptions from 'app/hooks/useOrgsOptions';
import { Role } from 'api/Users/types';
import usePaginationParams from 'app/hooks/usePaginationParams';
import { FilterParams } from 'app/types/Filters';
import { serviceTypeOptions } from 'components/Dashboard/Billing/helpers';
import { FilterProps } from 'components/Dashboard/types';
import { selectModelsApi } from 'store/exec/execSlice';
import { useAppSelector } from 'store/hooks';
import { selectMyUser } from 'store/users/usersSlice';

import { Button, Form, Select, Space } from 'antd';
import React from 'react';

const CreditTemplateFilter: React.FC<FilterProps> = ({ onApply, orgId }) => {
  const { role: myUserRole } = useAppSelector(selectMyUser);
  const modelsApi = useAppSelector(selectModelsApi);
  const [ form ] = Form.useForm<FilterParams>();
  const {
    orgParam,
    creditServiceTypeParam,
    modelApiParam,
    setFilters,
    clearFilters,
  } = usePaginationParams();
  const { orgsIdsOptions } = useOrgsOptions();

  const onReset = () => {
    form.setFieldValue('org', []);
    form.setFieldValue('creditServiceType', undefined);
    form.setFieldValue('modelApi', undefined);
    clearFilters();
  };

  const onFinish = (values: FilterParams) => {
    setFilters(values);
    onApply();
  };

  return (
    <Form
      form={form}
      name="creditTemplateFilter"
      layout="vertical"
      requiredMark={false}
      onFinish={onFinish}
      style={{ width: 290 }}
      initialValues={{
        org: orgParam !== '' ? orgParam.split(',') : [],
        creditServiceType: creditServiceTypeParam || undefined,
        modelApi: modelApiParam || undefined,
      }}
    >
      {myUserRole === Role.SYSTEM_ADMIN && !orgId && (
        <Form.Item name="org" label="Organizations">
          <Select placeholder="Select organizations" mode="multiple" options={orgsIdsOptions} />
        </Form.Item>
      )}

      <Form.Item name="creditServiceType" label="Service type">
        <Select placeholder="Select status" options={serviceTypeOptions} allowClear />
      </Form.Item>

      <Form.Item name="modelApi" label="Model API">
        <Select placeholder="Select model API" options={modelsApi} allowClear />
      </Form.Item>

      <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
        <Space>
          <Button onClick={onReset}>
            Reset
          </Button>
          <Button type="primary" htmlType="submit">
            Apply
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default CreditTemplateFilter;
